import { notificationPreferencesApi } from "../api";

/**
 * Read the news subscription state out of the toggle endpoint's response.
 *
 * The endpoint reports where it landed in prose ("User is subscribed" / "User is
 * not subscribed"). Test the negative FIRST: "subscribed" is a substring of
 * "not subscribed", so checking the positive first reports every unsubscribe as
 * a subscribe.
 *
 * @param {unknown} body
 * @returns {boolean|null} null when the wording is not recognised
 */
export const readNewsSubscriptionStatus = (body) => {
  const statusText =
    typeof body?.status === "string" ? body.status.toLowerCase() : "";

  if (statusText.includes("not subscribed")) return false;
  if (statusText.includes("subscribed")) return true;

  return null;
};

/**
 * Flip the news subscription and report the value the server confirmed.
 *
 * The caller's optimistic guess is never authoritative - the endpoint takes no
 * parameters and flips whatever it currently holds, so only the response says
 * where it ended up.
 *
 * @returns {Promise<{newsSubscription: boolean|null}>} newsSubscription is null
 *   when the response wording is unrecognised and the caller should re-read the user
 */
export const toggleNewsSubscription = async () => {
  const body = await notificationPreferencesApi.patchNewsSubscription();
  return { newsSubscription: readNewsSubscriptionStatus(body) };
};
